import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Item.css';

const Item = ({ id, name, image, new_price, old_price }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/product/${id}`);
  };

  return (
    <div className="item" onClick={handleClick}>
      <img src={image} alt={name} className="item-image" />
      <h2>{name}</h2>
      <div className="item-prices">
        <span className="item-old-price" style={{ textDecoration: 'line-through' }}>₹{old_price}</span>
        <span className="item-new-price">₹{new_price}</span>
      </div>
    </div>
  );
};

export default Item;
